import React from 'react';
import RotateLoader from 'react-spinners/RotateLoader';
import { popupLoaderStyle } from '../../consts/colors';
import { useStyles } from './PopupLoaderUseStyles';

const PopupLoader = () => {
  const classes = useStyles();

  return (
    <div className={`${classes.PopupLoader}__modal-container`}>
      <div className={`${classes.PopupLoader}__modal-container__loader`}>
        <RotateLoader color={popupLoaderStyle.color} size={40} margin={40} />
      </div>
    </div>
  );
};

export default PopupLoader;
